import { api } from "../api/client";

// Local cart cache used as a fallback when the BFF/Suitelet isn't
// reachable (dev / no auth / 404). The real cart still lives in
// NetSuite as a custom record once the API is up.
const KEY = "mr.b2b.localCart";

function loadLocal() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : { items: [] };
  } catch { return { items: [] }; }
}

function saveLocal(cart) {
  try { sessionStorage.setItem(KEY, JSON.stringify(cart)); } catch { /* quota */ }
  return cart;
}

async function withMock(promise, fallback) {
  try {
    const out = await promise;
    if (out && (out.items != null || Array.isArray(out))) return out;
    return fallback();
  } catch {
    return fallback();
  }
}

export const CartController = {
  get() {
    return withMock(api.getCart(), () => loadLocal());
  },
  update(items) {
    return withMock(api.updateCart(items), () => saveLocal({ items }));
  },
  async addItem(currentItems, sku, qty = 1) {
    const items = [...(currentItems || [])];
    const existing = items.find((i) => i.sku === sku);
    if (existing) existing.qty += qty;
    else items.push({ sku, qty });
    return withMock(api.updateCart(items), () => saveLocal({ items }));
  },
  async removeItem(currentItems, sku) {
    const items = (currentItems || []).filter((i) => i.sku !== sku);
    return withMock(api.updateCart(items), () => saveLocal({ items }));
  },
};
